import React, { ReactNode, useState } from 'react';
import Popover from '../popover/Popover';
import './NavMenu.scss';

interface INavMenuProps {
  disabled?: boolean;
  content: ReactNode;
}

export const NavMenu: React.FC<React.PropsWithChildren<INavMenuProps>> = ({ children, disabled, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="nav-menu">
      <Popover
        disabled={disabled}
        usePortal={false}
        content={<div className="nav-menu-container">{content}</div>}
        isOpen={isOpen}
        onInteraction={(state) => setIsOpen(state)}
        interactionKind="hover"
        position="bottom-right"
      >
        {children}
      </Popover>
    </div>
  );
};
export default NavMenu;
